import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TextEditor = ({ title, editorState, setEditorState }) => {
  console.log(title);
  console.log(editorState);
  return (
    <div>
      {title == "About Us" ? (
        <Editor
          editorClassName="border"
          editorStyle={{ minHeight: "400px" }}
          editorState={editorState}
          onEditorStateChange={setEditorState}
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "image",
              "history",
            ],
            inline: {
              options: ["bold", "italic", "underline", "strikethrough"],
            },
          }}
        />
      ) : (
        <Editor
          editorClassName="border"
          editorStyle={{ minHeight: "400px" }}
          editorState={editorState}
          onEditorStateChange={setEditorState}
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "history",
            ],
            inline: {
              options: ["bold", "italic", "underline", "strikethrough"],
            },
          }}
        />
      )}
    </div>
  );
};

export default TextEditor;
